import { c as _c } from "react/compiler-runtime";
import { Flex, formatAddress, ItemSide } from "@opensea/ui-kit";
import { ArrowBack, Check } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { useAccount, useConnect, useConnectors, useGetPreviouslyConnectedAccountsForConnector } from "../../../../../polychain/hooks";
import { FlowActions, FlowState } from "../../../../../stores/flowStore";
import { useConnectFlow } from "../../../../hooks/useConnectFlow";
import { ProfileDropdownItem, ProfileDropdownItemAvatar, ProfileDropdownItemContent, ProfileDropdownItemDescription, ProfileDropdownItemTitle } from "./ProfileDropdownItem";
export function SwitchWalletContent(t0) {
  const $ = _c(21);
  const {
    onCancel
  } = t0;
  const t = useTranslations("wallet.SwitchWalletContent");
  const account = useAccount();
  const {
    activeConnector,
    connectors
  } = useConnectors();
  let t1;
  if ($[0] !== onCancel) {
    t1 = e => {
      e.preventDefault();
      onCancel();
    };
    $[0] = onCancel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ProfileDropdownItemAvatar className="bg-transparent" icon={ArrowBack} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("back");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <ProfileDropdownItemContent><ProfileDropdownItemTitle>{t3}</ProfileDropdownItemTitle></ProfileDropdownItemContent>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <ProfileDropdownItem onClick={t1}>{t2}{t4}</ProfileDropdownItem>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== activeConnector) {
    t6 = activeConnector && <WalletOption connector={activeConnector} isConnected={true} />;
    $[10] = activeConnector;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== account || $[13] !== connectors) {
    let t8;
    if ($[15] !== account) {
      t8 = connector => connector.id !== account.connectorId;
      $[15] = account;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    t7 = connectors.filter(t8).map(_temp);
    $[12] = account;
    $[13] = connectors;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <>{t5}{t6}{t7}</>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function _temp(connector_0) {
  return <WalletOption connector={connector_0} key={connector_0.id} />;
}
export function WalletOption(t0) {
  const $ = _c(25);
  const {
    connector,
    isConnected
  } = t0;
  const {
    connect
  } = useConnect();
  const connectFlow = useConnectFlow();
  const getPreviouslyConnectedAccounts = useGetPreviouslyConnectedAccountsForConnector();
  const {
    flow
  } = useSnapshot(FlowState);
  let t1;
  if ($[0] !== connect || $[1] !== connectFlow || $[2] !== connector || $[3] !== flow) {
    t1 = async () => {
      if (connector.type === "embedded" && !connector.isConnected()) {
        connectFlow();
      } else {
        const address = await connect(connector);
        if (flow && flow.type === "view-wallet") {
          FlowActions.setFlowField("address", address);
        }
      }
    };
    $[0] = connect;
    $[1] = connectFlow;
    $[2] = connector;
    $[3] = flow;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== connector.icon) {
    t2 = connector.icon && <ProfileDropdownItemAvatar src={connector.icon} />;
    $[5] = connector.icon;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== connector.name) {
    t3 = <ProfileDropdownItemTitle>{connector.name}</ProfileDropdownItemTitle>;
    $[7] = connector.name;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== connector.id || $[10] !== getPreviouslyConnectedAccounts) {
    t4 = getPreviouslyConnectedAccounts(connector.id).map(_temp2).map(_temp3);
    $[9] = connector.id;
    $[10] = getPreviouslyConnectedAccounts;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <ProfileDropdownItemDescription className="text-start"><Flex className="flex-wrap justify-between gap-1 text-2xs">{t4}</Flex></ProfileDropdownItemDescription>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <ProfileDropdownItemContent>{t3}{t5}</ProfileDropdownItemContent>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isConnected) {
    t7 = isConnected && <ItemSide><Check /></ItemSide>;
    $[17] = isConnected;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== isConnected || $[20] !== t1 || $[21] !== t2 || $[22] !== t6 || $[23] !== t7) {
    t8 = <ProfileDropdownItem disabled={isConnected} onClick={t1}>{t2}{t6}{t7}</ProfileDropdownItem>;
    $[19] = isConnected;
    $[20] = t1;
    $[21] = t2;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
function _temp3(formattedAddress) {
  return <div key={formattedAddress}>{formattedAddress}</div>;
}
function _temp2(previouslyConnectedAccount) {
  return formatAddress(previouslyConnectedAccount.address);
}